import React, { useState, useEffect } from "react";
import CheckerDashboard from "./Safety_User_View/Observation_Dashboard/Checkerdashboard";
import MakerDashboard from "./Safety_User_View/Observation_Dashboard/Makerdashboard";
import InitializerDashboard from "./Safety_User_View/Observation_Dashboard/Initializerdashboard";
import SupervisorDashboard from "./Safety_User_View/Observation_Dashboard/Supervisordashboard";
import { resolveActiveProjectId } from "../../../api";
import { resolveSelectedWorkflowRole, getCurrentUserId } from "../../../utils/UserUtils";

export default function ObservationsDashboard() {
  const [activeRole, setActiveRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const activeProjectId =
        localStorage.getItem("ACTIVE_PROJECT_ID") ||
        localStorage.getItem("PROJECT_ID") ||
        localStorage.getItem("project_id") ||
        resolveActiveProjectId?.() ||
        "";

      const rawUserData = localStorage.getItem("USER_DATA");
      let userData = null;
      if (rawUserData && rawUserData !== "undefined" && rawUserData !== "null") {
        userData = JSON.parse(rawUserData);
      }

      const role = resolveSelectedWorkflowRole(userData, activeProjectId);
      setActiveRole(role);
    } catch (e) {
      console.error("Error resolving observation dashboard role:", e);
      setActiveRole(null);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted/40">
        <p className="text-sm text-muted-foreground">Loading workspace…</p>
      </div>
    );
  }

  const normalized = String(activeRole || "").trim().toUpperCase();

  if (normalized === "CHECKER") {
    return <CheckerDashboard />;
  }

  if (normalized === "MAKER") {
    return <MakerDashboard />;
  }

  if (normalized === "INITIALIZER" || normalized === "INTIALIZER") {
    return <InitializerDashboard />;
  }

  if (normalized === "SUPERVISOR") {
    return <SupervisorDashboard />;
  }

  // Safe unauthorized / unknown role boundary state (NEVER default to Checker)
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-6 text-center">
      <div className="max-w-md rounded-xl bg-white p-8 shadow-sm border border-slate-200">
        <h2 className="text-xl font-bold text-slate-800 mb-2">
          Role Not Selected or Unauthorized
        </h2>
        <p className="text-sm text-slate-600 mb-6">
          Your current workflow role is not authorized for observation management under the selected project context.
        </p>
        <button
          type="button"
          onClick={() => (window.location.href = "/config")}
          className="rounded-lg bg-orange-500 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-600 transition-colors"
        >
          Return to Workspace Config
        </button>
      </div>
    </div>
  );
}
